<div #wrapperElement class="profile-wrapper h-100">
  <div #headerElement class="profile-wrapper__topper">
    <span class="mr-4">
    <img (click)="goBackToMain()" [src]="weblinkIcons.back" width="20" height="20" alt="back" class="profile-wrapper__clickable">
    </span>
    <span class="profile-wrapper__topper-text mr-2">
      <img [src]="weblinkIcons.network_count" width="20" height="20" alt="netword">
      <span class="profile-wrapper__text-light ml-1"> {{mediaData?.network_count}} Networks </span>
    </span>
    <!-- <span class="float-right">
      <span class="profile-wrapper__text-light mr-1">Add Notes</span>
      <img [src]="weblinkIcons.note_white" width="20" height="20" alt="note">
    </span> -->
  </div>
  <div class="profile-wrapper__detail" [style.height.px]="contentHeight">
    <!-- logo -->
    <div class="profile-wrapper__detail-logo" *ngIf="mediaData?.type !== 'WC'">
      <img [src]="mediaData?.co_icon" alt="icon">
    </div>
    <!-- icon -->
    <div class="profile-wrapper__detail-icon">
      <div>
        <!-- others card -->
        <img *ngIf="mediaData?.type !== 'WC' && !(mediaData?.type === 'BC' && !mediaData?.is_comcard && mediaData?.is_private && !mediaData?.is_public)" [src]="mediaData?.co_logo" alt="logo">
        <!-- white card -->
        <img *ngIf="mediaData?.type === 'WC'" [src]="mediaData?.co_logo" alt="co_logo">
        <!-- black card -->
        <img *ngIf="(mediaData?.type === 'BC' && !mediaData?.is_comcard && mediaData?.is_private && !mediaData?.is_public)" [src]="mediaData?.co_logo" alt="co_logo">
      </div>
      <div class="profile-wrapper__text-bold">{{mediaData?.name}}</div>
      <div class="profile-wrapper__text-light">{{mediaData?.description}}</div>
    </div>
    <div class="profile-wrapper__detail-contain">
      <!-- header -->
      <div class="profile-wrapper__detail-header p-1">
        <span class="profile-wrapper__text-bold">My Profile</span>
      </div>
      <!-- title and description LANGUAGE -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.languages.length > 0">
        <div class="profile-wrapper__text-light">Language</div>
        <span class="profile-wrapper__text-light mb-1" *ngFor="let language of mediaData?.combine_profiles.languages; last as last">
          {{language}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <!-- title and description INTEREST -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.interests.length > 0">
        <div class="profile-wrapper__text-light">Interest</div>
        <span class="profile-wrapper__text-light mb-1" *ngFor="let interest of mediaData?.combine_profiles.interests; last as last">
          {{interest}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <!-- title and description EDUCATION -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.educations.length > 0">
        <div class="profile-wrapper__text-light">Highest Education</div>
        <span class="profile-wrapper__text-light mb-1" *ngFor="let education of mediaData?.combine_profiles.educations; last as last">
          {{education}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <!-- title and description AWARD -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.awards.length > 0">
        <div class="profile-wrapper__text-light">Awards</div>
        <span class="profile-wrapper__text-light mb-1" *ngFor="let award of mediaData?.combine_profiles.awards; last as last">
          {{award}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <!-- title and description CERTIFICATE -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.certificates.length > 0">
        <div class="profile-wrapper__text-light">Certifications</div>
        <span class="profile-wrapper__text-light mb-1" *ngFor="let award of certificate?.combine_profiles.certificates; last as last">
          {{certificate}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <!-- title and description ABOUT ME -->
      <div class="profile-wrapper__detail-title p-2" *ngIf="mediaData?.combine_profiles.about_me !== ''">
        <div class="profile-wrapper__text-light">About Me</div>
        <span class="profile-wrapper__text-light profile-wrapper__text-about mb-1"  style="white-space:pre-wrap;">
          {{mediaData?.combine_profiles.about_me}}
        </span>
      </div> 
    </div>
  </div>
</div>